export default {
  TableHeadHighValueReport: [
    [
      {
        displayName: 'report.highValueReport.datatable.number',
      },
      {
        displayName: 'report.highValueReport.datatable.roundId',
      },
      {
        displayName: 'report.highValueReport.datatable.currency',
      },
      {
        displayName: 'report.highValueReport.datatable.bet',
      },
      {
        displayName: 'report.highValueReport.datatable.winlose',
      },
      {
        displayName: 'report.highValueReport.datatable.gameName',
      },
      {
        displayName: 'report.highValueReport.datatable.username',
      },
      {
        displayName: 'report.highValueReport.datatable.timestamp',
      },
      {
        displayName: 'report.highValueReport.datatable.multiplier',
      },
    ],
  ],
};
